import request, { formatRequest } from "@/utils/request"

import { IImmersiveGuideDetail, IReturnReasonLocales } from "./type"

const APIOnboarding = {
  getReasonsLocales() {
    return request.get<{ data: IReturnReasonLocales }>(
      "/go-api/v1/setting/immersiveGuide/reasons",
    )
  },

  /**
   * 沉浸式引导详情
   * GET /go-api/v1/setting/immersiveGuide/detail
   */
  getImmersiveGuideDetail() {
    return formatRequest<IImmersiveGuideDetail>(
      request.get("/go-api/v1/setting/immersiveGuide/detail"),
    )
  },

  // 更新沉浸式引导
  updateImmersiveGuide(
    data: Omit<
      IImmersiveGuideDetail,
      "isCreatedGiftCard" | "isOpenStoreCredit" | "status"
    >,
  ) {
    return formatRequest(
      request.post("/go-api/v1/setting/immersiveGuide/save", data),
    )
  },

  // 跳过沉浸式引导
  skipImmersiveGuide() {
    return formatRequest(request.post("/go-api/v1/setting/immersiveGuide/skip"))
  },

  // 完成沉浸式引导
  completeImmersiveGuide() {
    return formatRequest(
      request.post("/go-api/v1/setting/immersiveGuide/complete"),
    )
  },

  // 获取一些用户标识 /go-api/v1/setting/immersiveGuide/shopifyFlags
  getShopifyFlags() {
    return formatRequest(
      request.get<{
        data: { is_open_store_credit: boolean; is_created_gift_card: boolean }
      }>("/go-api/v1/setting/immersiveGuide/shopifyFlags"),
    )
  },
}

export default APIOnboarding
